import styled from 'styled-components';

export const AssetReportHeaderStyle = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);
`;

export const AssetReportHeaderLabelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
`;

export const AssetReportHeaderTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
`;
export const AssetReportHeaderTypology = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  color: #747d93;
`;
export const AssetReportHeaderOperation = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  color: #1778fb;
`;
